import React from "react";


const ScreeningHOPI = () => {
    return (
        <div className="row">
            ScreeningHOPI
        </div>
    )
}

export default ScreeningHOPI;